import { GhostIcon, PartyPopperIcon, SparklesIcon, TreePineIcon } from "lucide-react";
import type { ElementType } from "react";

type MonthDay = { month: number; day: number };

export type ConfettiSeason = {
  id: "halloween" | "christmas" | "new-year" | "default";
  labelKey: string;
  icon: ElementType;
  keywords: string[];
  emojis?: string[];
};

type SeasonalConfetti = ConfettiSeason & { from: MonthDay; to: MonthDay };

const SEASONS: SeasonalConfetti[] = [
  {
    id: "halloween",
    from: { month: 10, day: 24 },
    to: { month: 10, day: 31 },
    labelKey: "CommandPaletteConfettiHalloween",
    icon: GhostIcon,
    keywords: ["halloween", "boo", "spooky"],
    emojis: ["🎃", "👻", "💀", "🦇", "🍬"],
  },
  {
    id: "christmas",
    from: { month: 12, day: 1 },
    to: { month: 12, day: 26 },
    labelKey: "CommandPaletteConfettiChristmas",
    icon: TreePineIcon,
    keywords: ["christmas", "xmas", "weihnachten"],
    emojis: ["🎄", "❄️", "🎁", "⭐"],
  },
  {
    id: "new-year",
    from: { month: 12, day: 31 },
    to: { month: 1, day: 1 },
    labelKey: "CommandPaletteConfettiNewYear",
    icon: SparklesIcon,
    keywords: ["new year", "silvester", "neujahr"],
    emojis: ["🎆", "🥂", "✨"],
  },
];

const DEFAULT_SEASON: ConfettiSeason = {
  id: "default",
  labelKey: "CommandPaletteConfetti",
  icon: PartyPopperIcon,
  keywords: [],
};

export function getConfettiSeason(date: Date = new Date()): ConfettiSeason {
  const today = toDayOfYearKey({ month: date.getMonth() + 1, day: date.getDate() });
  const season = SEASONS.find(({ from, to }) => {
    const [start, end] = [toDayOfYearKey(from), toDayOfYearKey(to)];
    return start <= end ? today >= start && today <= end : today >= start || today <= end;
  });

  return season ?? DEFAULT_SEASON;
}

function toDayOfYearKey({ month, day }: MonthDay): number {
  return month * 100 + day;
}
